// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4c81010c] .el-table .el-table__header-wrapper th {\n  height: 36px !important;\n}", ""]);
// Exports
module.exports = exports;
